import React from "react";

import { Redirect, BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Login } from "./login";
import { CheckLogin } from "./CheckLogin";

import Signin from "./arcade/platform/signin/index";
import AuthSignin from './arcade/platform/auth/index';

import "./App.css";

class Logout extends React.PureComponent {
    state = {
        loading: true,
    };
    componentDidMount() {
        fetch(`/api/logout`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
        })
        .then(response => response.json())
        .then(result => {
            this.setState({ loading: false });
        });
    }
    render() {
        if (this.state.loading) {
            return "";
        }
        return (<Redirect to={`/login`} />);
    }
}

function App() {
    return (
        <Router>
            <Switch>
                <Route path="/login" component={Login} />
                <Route path="/logout" component={Logout} />
                <Route path="/signin" component={Signin} />
                <Route path="/auth/signin" component={AuthSignin} />
                <Route component={CheckLogin} />
            </Switch>
        </Router>
    );
}

export default App;
